import mapKnownValues from "@/utils/mapKnownValues";
import Station from "@/classes/station";

export type ClusterAPIResponse = {
  id: string;
  cId: string;
  pKey: string;
  panelKey: null | string;
  cMaxAmps: number;
};

export default class Cluster {
  id = "";
  cId = "";
  pKey = "";
  panelKey: null | string = null;
  cMaxAmps = 32;

  constructor(params: Partial<Cluster> = {}) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: ClusterAPIResponse) {
    return new Cluster({
      ...response
    });
  }
}

export class ClusterTree {
  cluster = new Cluster();
  stations: Station[] = [];

  constructor(params: Partial<ClusterTree>) {
    mapKnownValues(this, params);
  }
}
